export default __webpack_public_path__ + "static/media/twitter-icon.24f57b53.png";